export const BG_PRIMARY = '#FEFEFE';
export const BG_SECONDARY = '#F9F7F4';
export const BG_ALTERNATIVE = '#cdc1b1';

export const BG_STEP_RSVP = '#997a5e';

export const TEXT_PRIMARY = '#1A1B1D';
export const TEXT_SECONDARY = '#1A1B1D';
export const TEXT_ALTERNATIVE = '#FEFEFE';

export const NAVIGATION_ICON_COLOR = '#FFFFFF';

export const HASHTAG_STYLE = {
  fontFamily: 'body',
  fontWeight: 'light',
  fontSize: '3xl',
  fontStyle: 'italic',
};

export const BUTTON_PROPS = {};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'light',
  size: 'sm',
  fontSize: 'xl',
  padding: '17px 40px',
  fontStyle: 'italic',
  type: 'button',
  bgColor: 'bgSecondary',
  color: 'secondaryColorText',
  fontFamily: 'body',
  borderRadius: '0',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#1A1B1D',
};
